import type { ErrorCode } from '@sprinters/shared';

/** Textes de l'interface (français). Centralisés pour faciliter une future traduction. */
export const fr = {
  errors: {
    INVALID_INPUT: 'Données invalides. Vérifiez votre pseudo (2 à 16 caractères) et le code.',
    ROOM_NOT_FOUND: "Ce salon n'existe pas (ou n'existe plus).",
    ROOM_FULL: 'Ce salon est complet.',
    NAME_TAKEN: 'Ce pseudo est déjà pris dans ce salon.',
    SESSION_INVALID: 'Votre session a expiré.',
    NOT_IN_ROOM: "Vous n'êtes dans aucun salon.",
    NOT_HOST: "Seul l'hôte peut faire cela.",
    BAD_STATE: "Action impossible pour l'instant.",
    FIELD_TOO_SMALL: 'Le tournoi est trop petit pour le nombre de joueurs présents.',
    RATE_LIMITED: 'Doucement ! Trop de requêtes.',
    INTERNAL: 'Erreur interne du serveur. Réessayez.',
  } satisfies Record<ErrorCode, string>,
  connection: {
    connecting: 'Connexion…',
    connected: 'En ligne',
    disconnected: 'Déconnecté, reconnexion…',
  },
};

export function errorMessage(code: ErrorCode): string {
  return fr.errors[code];
}
